BaseHandler = App.loadClass "core::reports/BaseHandler"
BaseOutput = App.loadClass "core::reports/BaseOutput"
ChartOutput = App.loadClass "core::reports/ChartOutput"

class exports.ReportsNBalanceSubHandler extends BaseHandler
    init: () ->
        @hasPrint       = false
        @parent.dialog.find('.print-btn').hide()
        @sourceUrl      = 'backend/grower/reports/n-balance/output/detail'
        @layoutUrl      = 'backend/grower/reports/n-balance/chart'
        @filterUrl      = 'backend/grower/reports/n-balance/filters'
        @layoutSelector = "#reports_n_balance_tab"

        $('.sidebar_content').find('.view-field-group-button-container').removeClass('hide')
        $('.sidebar_content').find('#view-field-group-button').prop('disabled', true)

        @initFilters()

        @borderWidth = 2
        @hoverBorderWidth = 3
        @fieldGroup = null


    afterLoadLayout: () ->
        super()

    initFilters: () ->
        @disableAllFilterGroups()

        @parent.filters.importGroup
            name: 'N Balance Report Filters'
            display_name: 'Report Filters'
            filters: [
                name: 'nbalance_years'
                display_name: 'Year'
                control_type: 'single_dropdown'
                deletable: false
                auto_select_first: true
            ,
                name: 'nbalance_crops'
                display_name: 'Crop'
                control_type: 'single_dropdown'
                deletable: false
                auto_select_only_value: true
                auto_select_first: true
            ,
                name: 'nbalance_previous_crops'
                display_name: 'Previous Crop'
                control_type: 'dropdown'
                deletable: true
            ,
                name: 'nbalance_distances'
                display_name: 'Distance'
                control_type: 'single_dropdown'
                values: [
                    { key: '50', value: 'Within 50 miles' }
                    { key: '100', value: 'Within 100 miles' }
                    { key: '150', value: 'Within 150 miles' }
                    { key: '200', value: 'Within 200 miles' }
                    { key: '250', value: 'Within 250 miles' }
                    { key: '300', value: 'Within 300 miles' }
                    { key: '350', value: 'Within 350 miles' }
                ]
            ,
                name: 'nbalance_operation_sizes'
                display_name: 'Operation Size'
                values: [
                    { key: '0-250', value: '0 - 250 acres' }
                    { key: '250-2500', value: '250 - 2500 acres' }
                    { key: '2500-5000', value: '2500 - 5000 acres' }
                    { key: '5000-', value: '5000+ acres' }
                ]
            ,
                name: 'nbalance_partners'
                display_name: 'Partner'
                control_type: 'dropdown'
                deletable: true
            ,
                name: 'nbalance_fields'
                display_name: 'Field'
                control_type: 'dropdown'
                deletable: true
            ,
                name: 'field_groups'
                display_name: 'Field Group'
                control_type: 'single_dropdown'
                deletable: false
                auto_select_first: true
                auto_select_only_value: true
                auto_clear_unavailable: true
            ,
                name: 'irrigation_type'
                display_name: 'Irrigation Type'
                control_type: 'option'
                deletable: true
                values: [
                    { key: 'dryland', value: 'Dryland' }
                    { key: 'irrigated', value: 'Irrigated' }
                ]
            ,
                name: 'nbalance_nitrogen_rates'
                display_name: 'Nitrogen Rate'
                control_type: 'dropdown'
                deletable: true
                values: [
                    { key: '0-50', value: '0 - 50 lbs/ac' }
                    { key: '50-100', value: '50 - 100 lbs/ac' }
                    { key: '100-150', value: '100 - 150 lbs/ac' }
                    { key: '150-200', value: '150 - 200 lbs/ac' }
                    { key: '200-250', value: '200 - 250 lbs/ac' }
                    { key: '250-300', value: '250 - 300 lbs/ac' }
                    { key: '300-350', value: '300 - 350 lbs/ac' }
                ]
            ,
                name: 'nbalance_components'
                display_name: 'N Component'
            ,
                name: 'output_type'
                display_name: 'Output Type'
                control_type: 'option'
                deletable: false
                values: [
                    { key: 'detail', value: 'Detail' }
                    { key: 'summary', value: 'Summary' }
                ]
                selected_values: [
                    { key: 'summary', value: 'Summary' }
                ]
            ]


        @setDefaultsAndRun(0, 0, 0, {}, 'up', false)

    destroy: () ->
        @parent.filters.removeGroup 'N Balance Report Filters'
        @parent.filters.enableGroup "Report Filters"

        @parent.dialog.find('.excel-btn').addClass('hidden')
        @parent.dialog.find('.info-popover').addClass('hide')
        super()

    getDataDetail: () =>
        # Always disable the button  when we're fetching new report output
        $('.sidebar_content').find('#view-field-group-button').prop('disabled', true)
        $('.sidebar_content').find('#view-field-group-button-spinner').removeClass('hide')

        return $.get('backend/grower/reports/n-balance/output/detail', { query: @filters }).then (data) =>
            $('.sidebar_content').find('#view-field-group-button-spinner').addClass('hide')

            # display error messages
            if data.status is 'error'
                @parent.msg.message_writer data.status, data.message
                return

            # Re-enable the button once we have report output
            $('.sidebar_content').find('#view-field-group-button').prop('disabled', false)

            data = JSON.parse(data)
            data.fieldGroup.field_group = @parent.filters.jsonize().filters.field_groups[0].value
            @fieldGroup = data.fieldGroup

            # Calculate total score and order by it descending
            records = _(data.reportData).map (record) =>
                record.score = record.fertilizer_score + record.manure_score + record.cover_crop_score - record.grain_score - record.residue_score
                return record
            .orderBy 'score', 'desc'
            .value()

            youIndex = _.findIndex(records, id: 'You')

            fertilizerBorderColors = Array(records.length).fill('#bdbdbd')
            fertilizerBorderColors.splice(youIndex, 1, '#00b0f0')

            manureBorderColors = Array(records.length).fill('#9871a8')
            manureBorderColors.splice(youIndex, 1, '#00b0f0')

            coverCropBorderColors = Array(records.length).fill('#498fbf')
            coverCropBorderColors.splice(youIndex, 1, '#00b0f0')

            grainBorderColors = Array(records.length).fill('#e3c946')
            grainBorderColors.splice(youIndex, 1, '#00b0f0')

            residueBorderColors = Array(records.length).fill('#ef8511')
            residueBorderColors.splice(youIndex, 1, '#00b0f0')

            legumeBorderColors = Array(records.length).fill('#00AD50')
            legumeBorderColors.splice(youIndex, 1, '#00b0f0')

            datasets = [
                {
                    label: 'Fertilizer (+)'
                    data: _.map(records, 'fertilizer_score')
                    fill: false
                    backgroundColor: '#bdbdbd'
                    borderColor: fertilizerBorderColors
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                    stack: 'N In'
                }
                {
                    label: 'Manure (+)'
                    data: _.map(records, 'manure_score')
                    fill: false
                    backgroundColor: '#9871a8'
                    borderColor: manureBorderColors
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                    stack: 'N In'
                }
                {
                    label: 'Cover Crop (+)'
                    data: _.map(records, 'cover_crop_score')
                    fill: false
                    backgroundColor: '#498fbf'
                    borderColor: coverCropBorderColors
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                    stack: 'N In'
                }
                {
                    label: 'Grain (-)'
                    data: _.map(records, 'grain_score')
                    fill: false
                    backgroundColor: '#e3c946'
                    borderColor: grainBorderColors
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                    stack: 'N Out'
                }
                {
                    label: 'Residue (-)'
                    data: _.map(records, 'residue_score')
                    fill: false
                    backgroundColor: '#ef8511'
                    borderColor: residueBorderColors
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                    stack: 'N Out'
                }
            ]

            datasets.unshift {
                label: 'Soybean (+)'
                data: _.map(records, 'legume_score')
                fill: false
                backgroundColor: '#00AD50'
                borderColor: legumeBorderColors
                borderWidth: @borderWidth
                hoverBorderWidth: @hoverBorderWidth
                stack: 'N In'
            } if _.filter(records, 'legume_score').length > 0

            # Remove datasets based on the N Components filter
            componentsFilters = @parent.filters.jsonize().filters.nbalance_components

            if componentsFilters.length > 0
                if not _.find(componentsFilters, { key: 'fertilizer' })
                    _.remove(datasets, { label: 'Fertilizer (+)' })
                if not _.find(componentsFilters, { key: 'manure' })
                    _.remove(datasets, { label: 'Manure (+)' })
                if not _.find(componentsFilters, { key: 'cover_crop' })
                    _.remove(datasets, { label: 'Cover Crop (+)' })
                if not _.find(componentsFilters, { key: 'grain' })
                    _.remove(datasets, { label: 'Grain (-)' })
                if not _.find(componentsFilters, { key: 'residue' })
                    _.remove(datasets, { label: 'Residue (-)' })
                if not _.find(componentsFilters, { key: 'soybean' })
                    _.remove(datasets, { label: 'Soybean (+)' })

            return {
                data:
                    labels: _.map(records, 'id')
                    datasets: datasets
                options:
                    legend:
                        display: true
                        position: 'bottom'
            }

    getDataSummary: () =>
        # Always disable the button  when we're fetching new report output
        $('.sidebar_content').find('#view-field-group-button').prop('disabled', true)
        $('.sidebar_content').find('#view-field-group-button-spinner').removeClass('hide')

        return $.get('backend/grower/reports/n-balance/output/detail', { query: @filters }).then (data) =>
            $('.sidebar_content').find('#view-field-group-button-spinner').addClass('hide')

            # display error messages
            if data.status is 'error'
                @parent.msg.message_writer data.status, data.message
                return

            data = JSON.parse(data)
            data.fieldGroup.field_group = @parent.filters.jsonize().filters.field_groups[0].value
            @fieldGroup = data.fieldGroup

            # Re-enable the button once we have report output
            $('.sidebar_content').find('#view-field-group-button').prop('disabled', false)

            # Calculate total score and order by it descending
            componentsFilters = @parent.filters.jsonize().filters.nbalance_components
            records = _(data.reportData).map (record) =>
                record.score = 0

                # Include data based on the N Components filter
                if componentsFilters.length is 0 or _.find(componentsFilters, { key: 'fertilizer' })
                    record.score += record.fertilizer_score

                if componentsFilters.length is 0 or _.find(componentsFilters, { key: 'manure' })
                    record.score += record.manure_score

                if componentsFilters.length is 0 or _.find(componentsFilters, { key: 'cover_crop' })
                    record.score += record.cover_crop_score

                if (componentsFilters.length is 0 or _.find(componentsFilters, { key: 'soybean' })) and record.legume_score?
                    record.score += record.legume_score

                record.score -= record.grain_score + record.residue_score

                record.score = +record.score.toFixed(2)

                return record
            .orderBy 'score', 'desc'
            .value()

            backgroundColors = _.map records, (record) =>
                # Red for things outside the range
                if record.score < 25 or record.score > 75
                    return 'rgba(207, 27, 27, 0.6)'

                # Green otherwise
                return 'rgba(29, 139, 50, 0.6)'

            borderColors = _.map records, (record) =>
                # Blue for you (heh it rhymes)
                if record.id is 'You'
                    return '#00b0f0'

                # Red for things outside the range
                if record.score < 25 or record.score > 75
                    return '#d71b07'

                # Green otherwise
                return '#1d8b32'

            datasets = [
                {
                    label: 'Score'
                    data: _.map(records, 'score')
                    fill: false
                    backgroundColor: backgroundColors
                    borderColor: borderColors
                    borderWidth: @borderWidth
                    hoverBorderWidth: @hoverBorderWidth
                }
            ]

            return {
                data:
                    labels: _.map(records, 'id')
                    datasets: datasets
                options:
                    legend:
                        display: false
            }

    beforeApply: () ->
        filters = @parent.filters.jsonize()

        firstLoad = not @currentOutput?

        if filters.filters.output_type[0].key is 'detail'
            unless @currentOutput? and @parent.appliedFilters?.filters.output_type[0].key is 'detail'
                xAxes = [
                    stacked: true
                    scaleLabel:
                        display: true
                        labelString: 'Anonymous Grower ID'
                        fontSize: 20
                ]
                yAxes = [
                    stacked: true
                    scaleLabel:
                        display: true
                        labelString: 'N Inputs (+) and N Outputs (-) (lbs/ac)'
                        fontSize: 20
                ]

                @currentOutput?.destroy()
                @currentOutput = new ChartOutput this, @parent, @sourceUrl, 'bar', xAxes, yAxes, {}, @getDataDetail
        else
            unless @currentOutput? and @parent.appliedFilters?.filters.output_type[0].key is 'summary'
                xAxes = [
                    scaleLabel:
                        display: true
                        labelString: 'N Balance (N lbs/ac)'
                        fontSize: 20
                ]
                yAxes = [
                    scaleLabel:
                        display: true
                        labelString: 'Grower Rank'
                        fontSize: 20
                ]
                @currentOutput?.destroy()
                @currentOutput = new ChartOutput this, @parent, @sourceUrl, 'horizontalBar', xAxes, yAxes, {
                    plugins:
                        lineAtValues: [
                            {
                                value: 25
                                color: '#ffc000'
                                width: 3
                            }
                            {
                                value: 75
                                color: '#ffc000'
                                width: 3
                            }
                        ]
                }, @getDataSummary

        return firstLoad
